/**
 * This is just an interface for the AudioWorkletProcessor
 */
export class AudioWorkletProcessor {
    constructor(_options) {
        this.parameterDescriptors = [];
        this.port = new MessagePort();
    }
    process(_inputs, _outputs, _parameters) {
        return false;
    }
}
//# sourceMappingURL=AudioWorkletProcessor.worklet.js.map